export const MAX_CLOSEST_DEALERS = 2;
export const COUNT_LABEL = '{count}';
